import React, { useState, useEffect } from "react";
import Axios from "axios";
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardImg,
    CardTitle,
    CardText,
} from "reactstrap";
import { Link } from "react-router-dom";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const BlogPage = () => {
    const [dataBlog, setDataBlog] = useState([]);
    const [dataGroupBlog, setDataGroupBlog] = useState([]);
    const [activeCategory, setActiveCategory] = useState("ALL");

    const getDataBlog = async () => {
        const response = await Axios.get(`${process.env.REACT_APP_API_URL}/blog/readBlog`);
        setDataBlog(response.data);
    };

    const getDataGroupBlog = async () => {
        const response = await Axios.get(`${process.env.REACT_APP_API_URL}/blog/readGroupBlog`);
        setDataGroupBlog(response.data);
    };

    useEffect(() => {
        getDataBlog();
        getDataGroupBlog();
    }, []);

    const BlogHeader = ({ activeCategory, setActiveCategory }) => (
        <Container className="blog-header-main">
            <Row className="blog-header">
                <Col className="blog-header-wrapper">
                    <Button
                        color="primary"
                        className={`category-button ${activeCategory === "ALL" ? "active" : ""}`}
                        onClick={() => setActiveCategory("ALL")}
                    >
                        ALL
                    </Button>
                    {dataGroupBlog.map((category, index) => (
                        <Button
                            key={index}
                            color="primary"
                            className={`category-button ${
                                category.group_name === activeCategory ? "active" : ""
                            }`}
                            onClick={() => setActiveCategory(category.group_name)}
                        >
                            {category.group_name}
                        </Button>
                    ))}
                </Col>
            </Row>
        </Container>
    );

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "2-digit" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const truncateText = (text, wordLimit) => {
        if (!text) return ""; // If text is undefined, return an empty string
        const words = text.split(" ");
        return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
    };

    const filteredPosts =
        activeCategory === "ALL"
            ? dataBlog
            : dataBlog.filter((post) => post.group_name === activeCategory);

    const generateSlug = (title) => {
        if (!title) return ""; // If title is undefined, return an empty string
        return title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
    };

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <div id="blog">
                    <div className="title">
                        <h2>YKBUT NEWS</h2>
                    </div>
                    <BlogHeader
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                    />
                </div>
                <Container className="blog-page">
                    {filteredPosts.map((post, index) => (
                        <CardBody>
                            <Row className="post-header">
                                <Col>
                                    <p className="post-header-category">{post.group_name}</p>
                                    <hr className="header-divider" />
                                </Col>
                            </Row>
                            <Row className="post-main">
                                <Col md="4">
                                    <CardImg
                                        top
                                        width="100%"
                                        src={post.foto_main}
                                        alt={post.title}
                                        className="main-image"
                                    />
                                </Col>
                                <Col md="8" className="post-details">
                                    <CardTitle tag="h2" className="post-title">
                                        {post.title}
                                    </CardTitle>
                                    <CardText className="post-description">
                                        {truncateText(post.detail_foto_main, 30)}
                                    </CardText>
                                    <CardText className="post-date">
                                        {formatDate(post.tanggal_foto_main)}
                                    </CardText>
                                    <Link to={`/detail-blog/${generateSlug(post.title)}`}>
                                        <Button color="primary" className="button-blog">
                                            Read More
                                        </Button>
                                    </Link>
                                </Col>
                            </Row>
                            <Row className="post-images mt-4">
                                {[post.foto_satu, post.foto_dua, post.foto_tiga].map((foto, i) => (
                                    <Col key={i} md="4" className="image-thumbnail-wrapper mb-4">
                                        <Card>
                                            <CardImg
                                                top
                                                width="100%"
                                                src={foto}
                                                alt={`post image ${i + 1}`}
                                                className="image-thumbnail"
                                            />
                                            <CardBody>
                                                <CardTitle tag="p" className="image-titles">
                                                    {truncateText(post[`title_foto_${i + 1}`], 10)}
                                                </CardTitle>
                                                <CardText className="image-description">
                                                    {truncateText(post[`detail_foto_${i + 1}`], 10)}
                                                </CardText>
                                                <CardText className="image-date">
                                                    {formatDate(post[`tanggal_foto_${i + 1}`])}
                                                </CardText>
                                                <Link
                                                    to={`/detail-blog/${generateSlug(
                                                        post[`title_foto_${i + 1}`]
                                                    )}`}
                                                    className="image-button"
                                                >
                                                    <Button color="primary" className="button-blog">
                                                        Read More
                                                    </Button>
                                                </Link>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                    ))}
                </Container>
                <DefaultFooter />
            </div>
        </>
    );
};

export default BlogPage;
